import { useEffect } from 'react';
import { ScheduleV2 } from '@frontend/api-schedule-v2';
import { useAppScopeStore } from '@frontend/scope';
import { useQuickFillRecipientShallowStore } from '../store';

export const useSetRecipientCounts = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { setTotalCounts } = useQuickFillRecipientShallowStore('setTotalCounts');

  // Fetch Quick Fill recipient count for all locations
  const { data, isLoading } = ScheduleV2.Queries.useCountQuery({
    request: { locationIds: selectedLocationIds },
    options: { enabled: !!selectedLocationIds?.length },
  });

  useEffect(() => {
    if (!isLoading && data?.quickfillCount) {
      setTotalCounts(data.quickfillCount);
    }
  }, [data, isLoading, setTotalCounts]);
};
